import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import Box from "@mui/material/Box";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import {Button, Divider, Grid, IconButton} from "@mui/material";
import InputField from "../../components/InputField";
import {Add, Edit, QrCode2Outlined} from "@mui/icons-material";
import ModalPage from "../../components/ModalPage";
import TableData from "../../components/TableData";
import AddTruck from "./AddTruck";
import qrcode from "qrcode";
import DisplayQrcode from "./DisplayQrcode";
import TableView from "../../components/TableView";

export default function Truck(props) {
    const modal = useRef();
    const [name, setName] = useState();
    const [data, setData] = useState({total: 0, data: []});
    const [startDate, setStartDate] = useState();
    const [showProgress, setShowProgress] = useState(false);

    useEffect(() => {
        loadData();
    }, [name]);
    const loadData = () => {
        let url = `${BASE_URL}api/settings/truck?data=data`;
        if (name) {
            url += `&plateNumber=${name}`;
        }

        setShowProgress(true);
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
                setShowProgress(false)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const updateTruck = (data) => {
        let component = <AddTruck loadData={loadData} modal={modal} data={data}/>;
        modal.current.show('Truck', component, '30%');
    }

    const addTruckModel = () => {
        let component = <AddTruck loadData={loadData} modal={modal}/>;
        modal.current.show('Truck', component, '30%');
    }

    const truckDetails = (data) => {
        // let component = <TruckDetails loadData={loadData} modal={modal} employeeId={data?.userId}/>;
        // modal.current.show('Truck', component, "60%");
    }

    const generateQRCode = (item) => {
        qrcode.toDataURL(
            `${window.location.origin}/rate-review/${item?.truckId}`,
            {
                width: 800,
                margin: 2,
                color: {
                    dark: "#335383FF",
                    light: "#EEEEEEFF",
                },
            },
            (err, url) => {
                if (err) throw new Error(err);
                let component = <DisplayQrcode qrcode={url}/>;
                modal.current.show("Qr-code", component, "20%");
            }
        );
    };

    return (
        <>
            <Box>
                <Grid container spacing={1} sx={{mb: 2}}>
                    <Grid item xs={3}>
                        <InputField
                            placeholder="Plate Number"
                            onChange={(value) => setName(value)}
                        />
                    </Grid>
                    <Grid item xs={8}/>
                    <Grid item xs={1}>
                        <Button
                            startIcon={<Add/>}
                            disableElevation sx={{textTransform: "none"}}
                            fullWidth size="medium"
                            variant="contained" color="primary"
                            onClick={() => addTruckModel()}>
                            Truck
                        </Button>
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <TableView
                            showProgres={showProgress}
                            url="customer/customer"
                            title="List"
                            columns={[
                                {id: 'plateNumber', label: 'Plate Number',},
                                {id: 'chasesNumber', label: 'Chases Number',},
                                {id: 'truckMake', label: 'Make',},
                                {id: 'truckModel', label: 'Model'},
                                {id: 'capacity', label: 'Seat Capacity'},
                                {id: 'fuelType', label: 'Fuel Type'},
                                {
                                    id: 'status',
                                    label: 'QR Code',
                                    disabled: true,
                                    customerRender: true,
                                    valueGetter: (item) => (
                                        <IconButton size="small"
                                                    onClick={() => generateQRCode(item)}><QrCode2Outlined/></IconButton>)
                                },
                                {
                                    id: 'action',
                                    label: 'Action',
                                    minWidth: "small",
                                    disabled: true,
                                    customerRender: true,
                                    valueGetter: (item) => (
                                        <IconButton size="small" onClick={() => updateTruck(item)}><Edit/></IconButton>)
                                },
                            ]}
                            rows={data}
                            rowClick={true}
                            rowFunction={(item) => truckDetails(item)}
                        />
                    </Grid>
                </Grid>
            </Box>
            <ModalPage ref={modal}/>
        </>
    );
}